__webpack_nonce__ = "CSP_NONCE_PLACEHOLDER";